import ApiService from '../api.services';

const LayoutService = {
  list: async function () {
    try {
      const response = await ApiService.get('/api/layout');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  type: async function (type) {
    try {
      const response = await ApiService.get(`/api/layout/${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async function (filter, value) {
    try {
      const response = await ApiService.get(`/api/layout/${filter}/${value}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  add: async function (form) {
    const data = {
      layout: form
    }
    try {
      const response = await ApiService.post('/api/layout', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async function (id, form) {
    const data = {
      layout: form
    }
    try {
      const response = await ApiService.put(`/api/layout/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async function (id) {
    try {
      const response = await ApiService.delete(`/api/layout/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default LayoutService;

export { LayoutService };

